import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarCheck } from "lucide-react";
import { trackEvent } from "../../lib/analytics";

/** Reusable bottom-of-page conversion CTA band used across all marketing pages. */
export function MarketingCTA({ heading, sub }) {
  return (
    <section className="border-t border-white/10 bg-gradient-to-br from-blue-600/10 via-slate-950 to-slate-950">
      <div className="max-w-4xl mx-auto px-5 lg:px-8 py-16 text-center">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-3">{heading}</h2>
        {sub && <p className="text-slate-400 max-w-xl mx-auto mb-8">{sub}</p>}
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/signup"
            data-testid="marketing-cta-trial"
            onClick={() => trackEvent("cta_click", { cta_name: "start_free_trial", page_path: window.location.pathname })}
            className="inline-flex items-center gap-2 rounded-full bg-blue-600 hover:bg-blue-500 text-white text-[14px] font-bold px-6 py-3.5 transition-colors"
          >
            Start Your Free Trial <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            to="/pricing"
            data-testid="marketing-cta-pricing"
            onClick={() => trackEvent("cta_click", { cta_name: "see_pricing", page_path: window.location.pathname })}
            className="inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/15 hover:bg-white/10 text-white text-[14px] font-bold px-6 py-3.5 transition-colors"
          >
            <CalendarCheck className="h-4 w-4" /> See Pricing
          </Link>
        </div>
      </div>
    </section>
  );
}
